var link_viewer_wrapper_rtlignore_default = {
  "anchor": "Aa65O",
  "link": "_67DzM"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
